import React, { Component } from 'react'
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { bindActionCreators } from 'redux';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { AC_LIST_FEEDBACK, AC_RESET_FEEDBACK } from '../../../actions/reviewAction';
import { AC_LIST_HOTEL } from '../../../actions/hotelAction';
import ImportedURL from '../../../common/api';
import axios from 'axios';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Error, Success } from '../../../common/swal';
import Spinner from 'react-bootstrap/Spinner';
import { Row } from 'react-bootstrap';
import { onErrorImage } from '../../../common/validate';

const initialState = {
    columnDefs: [
        // { headerName: '#', valueGetter: "node.rowIndex+1", width: 100, sortable: false, filter: false, cellStyle: { 'text-align': 'center' } },
        {
            headerName: 'Logo', width: 100, field: 'logo', sortable: false, filter: false, "resizable": false,
            cellRenderer: function (params) {
                return `<img src=${ImportedURL.FILEURL + params.data.logo} alt='' width='65px' height='65px' class="contain_image"/>`;
            }
        },
        {
            headerName: 'Hotel ', field: 'hotelName', width: 150, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.hotelName)
                    return `${params.data.hotelName}`;
                else return '---'
            }
        },
        {
            headerName: 'Name', field: 'name', width: 150, cellStyle: { 'text-align': 'center' }, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.name) {
                    return params.data.name
                } else {
                    return '---'
                }
            }
        },
        {
            headerName: 'Room No.', field: 'roomno', width: 100, cellStyle: { 'text-align': 'center' }, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.roomno) {
                    return params.data.roomno
                } else {
                    return '---'
                }
            }
        },
        {
            headerName: 'Phone No.', field: 'phone', width: 150, cellStyle: { 'text-align': 'center' }, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.phone || params.data.cc) {
                    return (params.data.cc ? params.data.cc + " " : '') + (params.data.phone ? params.data.phone : '');
                } else {
                    return '---'
                }
            }
        },
        {
            headerName: 'Feedback', field: 'feedback', width: 150, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.feedback) {
                    return (params.data.feedback);
                } else {
                    return '---'
                }
            }
        },
        {
            headerName: 'Sent On', field: 'date_text_sent', width: 150, cellStyle: { 'text-align': 'center' },
            valueGetter: function (params) {
                return moment(params.value).format(params.data.dtFormat);
            }
        },
        {
            headerName: 'Action', width: 150, sortable: false, filter: false, cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
            template:
                `<i class="fa fa-eye" type="button" style='color: #1DC9B7 !important' data-action-type="View" data-toggle="modal" data-target="#listreportmodel"></i>`,
        },
    ],
    defaultColumDef: {
        // "width": 200,
        // "filter": true,
        // "sortable": true,
        // "resizable": true,
        editable: false,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 100,
    },
    feedbacks: [],
    orignalData: [],
    hotel: '',
    currentPage: 1,
    todosPerPage: 25,
    upperPageBound: 3,
    lowerPageBound: 0,
    isPrevBtnActive: 'disabled',
    isNextBtnActive: '',
    pageBound: 3,
    feedbackData: {},
    gridView: false,
    hideReset: false,
    replyid: '',
    hotelName: '',
    hotelLabel: '',
    spinner: false,
    fromDate: moment(new Date().setDate(new Date().getDate() - 5)).format('YYYY-MM-DD'),
}

class ListFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    // Grid funtions
    onRowClicked = event => {
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        if (value === 'View') {
            this.setState({ feedbackData: event.data })
        }
    }

    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }

    generateColumnsForExcel() {
        const keys = this.gridColumnApi
            .getAllDisplayedColumns()
            .map(column => column.getColId())
        return keys;
    }

    exportToCSV = () => {
        const account = this.props.AccountState.account;
        this.gridApi.exportDataAsCsv({
            columnKeys: ['hotelName', 'roomno', 'name', 'phone', 'feedback', 'date_text_sent'],
            fileName: "reports" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }

    // Export function

    exportPDF = () => {
        const account = this.props.AccountState.account;
        var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + "  " + (account.timeformat != '' ? account.timeformat : "hh:mm A")
        var tzone = 'America/chicago'
        if (account != undefined && account && account.tzone != undefined && account.tzone) {
            tzone = account.tzone
        }
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 15;
        const doc = new jsPDF(orientation, unit, size);

        var img = new Image();
        img.src = '../../assets/images/logo.png';

        doc.setFontSize(15);
        const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - Report List" : "Report List") : "Report List";
        if (this.state.hotelName) {
            var headers = [['#', "Room No.", "Name", "Phone No.", 'Feedback', 'Sent On']];
            var data = this.state.feedbacks.map((elt, i) => [
                i + 1,
                elt.roomno ? elt.roomno : '---',
                elt.name ? elt.name : '---',
                elt.phone ? elt.phone : '---',
                elt.feedback ? elt.feedback : '---',
                moment(elt.date_text_sent).format(dtFormat),
            ]);
        }
        else {
            var headers = [['#', "Hotel", "Room No.", "Name", "Phone No.", 'Feedback', 'Sent On']];
            var data = this.state.feedbacks.map((elt, i) => [
                i + 1,
                elt.hotelName,
                elt.roomno ? elt.roomno : '---',
                elt.name ? elt.name : '---',
                elt.phone ? elt.phone : '---',
                elt.feedback ? elt.feedback : '---',
                moment(elt.date_text_sent).format(dtFormat),
            ]);
        }
        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                rowHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10,
                bottom: 70,
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        // doc.text('MyHotel AI', 710, 40)
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            if (this.state.hotelName) {
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hotelNameExport, 20, 545);
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hoteladdressExport, 20, 560);
            }
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            const fullText = 'This is an auto-generated report from MyHotel AI (www.myhotelai.com)';
            const coloredText = '(www.myhotelai.com)';
            const textColor = [28, 48, 120]; // Specify your desired text color as an RGB array

            const textXPosition = 20;
            const textYPosition = 575;

            // Calculate the width of the full text before the colored text
            const fullTextWidth = doc.getTextWidth(fullText);
            const coloredTextWidth = doc.getTextWidth(coloredText);
            const leadingText = fullText.slice(0, fullText.indexOf(coloredText));

            // Render the leading text with default color
            doc.setTextColor(110); // Set default text color
            doc.text(leadingText, textXPosition, textYPosition);

            // Render the colored text with the specified color
            doc.setTextColor(textColor[0], textColor[1], textColor[2]);
            doc.text(coloredText, textXPosition + fullTextWidth - coloredTextWidth, textYPosition);
        }
        doc.save("reports" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf")
    }

    // Filter functions

    handleChange = e => {
        const { name, value, label } = e;
        // e.preventDefault();
        // const regex = new RegExp(value, 'i');
        var filtered = [];
        this.getData({ fromDate: this.state.fromDate, toDate: this.state.toDate, hotel: value })
        this.setState({
            hotel: value, hotelName: label, hideReset: true, hotelLabel: e
        });
    }

    filterReset = (e) => {
        const account = this.props.AccountState.account;
        let from = moment(new Date().setDate(new Date().getDate() - 5)).format('YYYY-MM-DD');
        if (ImportedURL.SUPERADMIN.includes(account.role)) {
            this.setState({ hotelName: '', fromDate: from, toDate: '', hideReset: false, hotelLabel: "" });
        } else {
            this.setState({ fromDate: from, toDate: '', hideReset: false, });
        }
        this.getData({ fromDate: from });
    }

    setDate = (e) => {
        const { name, value } = e.target;

        this.setState({ hideReset: true, [name]: value, })
        if (name == 'fromDate') {
            this.getData({ fromDate: value ? value + "T00:00:00" : '', toDate: this.state.toDate ? this.state.toDate + "T23:59:59" : '', hotel: this.state.hotel })
        }

        if (name == 'toDate') {
            this.getData({ fromDate: this.state.fromDate ? this.state.fromDate + "T00:00:00" : '', toDate: value ? value + "T23:59:59" : '', hotel: this.state.hotel })
        }
    }

    //Get data format
    getDate = (date) => {
        const account = this.props.AccountState.account;
        var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + "  " + (account.timeformat != '' ? account.timeformat : "hh:mm A")
        var tzone = 'America/chicago'
        if (account != undefined && account && account.tzone != undefined && account.tzone) {
            tzone = account.tzone
        }
        if (!date) return '';
        return moment(date).format(dtFormat);
    }

    componentDidMount() {
        this.setState({ spinner: true })
        this.getData({ fromDate: this.state.fromDate });
        const account = this.props.AccountState.account;
        this.setState({ hotelName: account.hotelName ? account.hotelName : '' });
    }

    getData = (filter) => {
        axios.get(ImportedURL.API.getGuestFeedback, { params: filter })
            .then((res) => {
                if (res.data)
                    this.setState({ feedbacks: res.data, orignalData: res.data, })
                this.setState({ spinner: false })

            }).catch((err) => {
                this.setState({ spinner: false })
                console.log(err);
            });
    }
    // Pagination functions
    setPrevAndNextBtnClass = (listid) => {
        let totalPage = Math.ceil(this.state.feedbacks.length / this.state.todosPerPage);
        this.setState({ isNextBtnActive: 'disabled' });
        this.setState({ isPrevBtnActive: 'disabled' });
        if (totalPage === listid && totalPage > 1) {
            this.setState({ isPrevBtnActive: '' });
        }
        else if (listid === 1 && totalPage > 1) {
            this.setState({ isNextBtnActive: '' });
        }
        else if (totalPage > 1) {
            this.setState({ isNextBtnActive: '' });
            this.setState({ isPrevBtnActive: '' });
        }
    }

    btnIncrementClick = () => {
        this.setState({ upperPageBound: this.state.upperPageBound + this.state.pageBound });
        this.setState({ lowerPageBound: this.state.lowerPageBound + this.state.pageBound });
        let listid = this.state.upperPageBound + 1;
        this.setState({ currentPage: listid });
        this.setPrevAndNextBtnClass(listid);
    }
    btnDecrementClick = () => {
        this.setState({ upperPageBound: this.state.upperPageBound - this.state.pageBound });
        this.setState({ lowerPageBound: this.state.lowerPageBound - this.state.pageBound });
        let listid = this.state.upperPageBound - this.state.pageBound;
        this.setState({ currentPage: listid });
        this.setPrevAndNextBtnClass(listid);
    }

    btnPrevClick = () => {
        if ((this.state.currentPage - 1) % this.state.pageBound === 0) {
            this.setState({ upperPageBound: this.state.upperPageBound - this.state.pageBound });
            this.setState({ lowerPageBound: this.state.lowerPageBound - this.state.pageBound });
        }
        let listid = this.state.currentPage - 1;
        this.setState({ currentPage: listid });
        this.setPrevAndNextBtnClass(listid);
    }
    btnNextClick = () => {
        if ((this.state.currentPage + 1) > this.state.upperPageBound) {
            this.setState({ upperPageBound: this.state.upperPageBound + this.state.pageBound });
            this.setState({ lowerPageBound: this.state.lowerPageBound + this.state.pageBound });
        }
        let listid = this.state.currentPage + 1;
        this.setState({ currentPage: listid });
        this.setPrevAndNextBtnClass(listid);
    }

    handleClick = (event) => {
        let listid = Number(event.target.id);
        this.setState({
            currentPage: listid
        });
        this.setPrevAndNextBtnClass(listid);
    }

    render() {
        const { HotelState, AccountState, ReviewState } = this.props;
        const { feedbacks, currentPage, todosPerPage, upperPageBound, lowerPageBound, isPrevBtnActive, isNextBtnActive } = this.state;

        const rowData = this.state.feedbacks;
        const spinner = this.state.spinner;
        const listHotels = HotelState.listhotels;
        const languageData = AccountState.account.SelectedlanguageData
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const currentfeedbacks = feedbacks.slice(indexOfFirstTodo, indexOfLastTodo);

        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(feedbacks.length / todosPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            if (currentPage === number) {
                return (
                    <li key={number} className='page-item active' id={number}><a className="page-link" role='button' id={number} onClick={this.handleClick}>{number}</a></li>
                )
            }
            else if ((number < upperPageBound + 1) && number > lowerPageBound) {
                return (
                    <li key={number} id={number} className='page-item'><a className="page-link" role='button' id={number} onClick={this.handleClick}>{number}</a></li>
                )
            }
        });
        let pageIncrementBtn = null;
        if (pageNumbers.length > upperPageBound) {
            pageIncrementBtn = <li className="page-item"><a className="page-link" role='button' onClick={this.btnIncrementClick}>&hellip;</a></li>
        }
        let pageDecrementBtn = null;
        if (lowerPageBound >= 1) {
            pageDecrementBtn = <li className="page-item"><a className="page-link" role='button' onClick={this.btnDecrementClick}>&hellip;</a></li>
        }
        let renderPrevBtn = null;
        if (isPrevBtnActive === 'disabled') {
            renderPrevBtn = <li className="page-item"><a className="page-link" role='button'>Prev</a></li>
        }
        else {
            renderPrevBtn = <li className="page-item"><span className="page-link" role='button' onClick={this.btnPrevClick}>Prev</span></li>
        }
        let renderNextBtn = null;
        if (isNextBtnActive === 'disabled' || renderPageNumbers.length == 1) {
            renderNextBtn = <li className="page-item"><a className="page-link" role='button'>Next</a></li>
        }
        else {
            renderNextBtn = <li className="page-item"><span className="page-link" role='button' onClick={this.btnNextClick}>Next</span></li>
        }


        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        const account = AccountState.account;
        var hotelOptionsSearch = [];
        if (listHotels.length > 1) {
            hotelOptionsSearch.push({ label: 'All', value: '', name: 'hotel' })
        }
        if (listHotels.length > 0) {
            listHotels.filter(filterItem => filterItem.status === true && filterItem.tripsadvisorurl && filterItem.googlereviewurl && filterItem.guesttouchid).map(item => {
                if (ImportedURL.SUPERADMIN.includes(account.role)) {
                    hotelOptionsSearch.push({ label: `${item.name} ${item.city} ${item.state}`, value: item._id, logo: item.logo, name: 'hotel' });
                }
            })
        }

        const viewfeedbackData = this.state.feedbackData;
        var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat != '' ? account.timeformat : "hh:mm A")
        if (rowData) {
            rowData.forEach(object => {
                object.dtFormat = dtFormat;
            });
        }


        // currentfeedbacks && currentfeedbacks.map((data, i) => {
        //     data.replies && data.replies.map((item, j) => {
        //  
        //         var today = new Date(item.postedOn);
        //         var Christmas = new Date((data.createdAt));
        //         var diffMs = (today -Christmas ); // milliseconds between now & Christmas
        //         var diffDays = Math.floor(diffMs / 86400000); // days
        //         var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        //         var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
        //     })
        // })
        return (
            <>
                <div>
                    <div >
                        <div className="breadcrump">
                            <p> <Link to="/"><h6>{languageData && languageData.DASHBOARD ? languageData.DASHBOARD : "Dashboard"}</h6></Link>  <span><i className="fa fa-angle-right" aria-hidden="true"></i> </span>  <Link to="/feedbacks"><h6 className="highlights_breadcrump"> {languageData && languageData.FEEDBACKS ? languageData.FEEDBACKS : "Feedback"}</h6></Link></p>
                        </div>
                        <div className="section-body pt-3">
                            <div className='review_sec'>
                                <div className="container-fluid">
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="card-header top_title_icon">
                                                        <div className='rounded_icon'><i className="fa fa-comments mr-2"></i></div>
                                                        <h3 className="card-title top_title common_title_fs"> {languageData && languageData.FEEDBACKS ? languageData.FEEDBACKS : "Feedback"}</h3>
                                                        <div className="card-options">
                                                            <div className="input-group">
                                                                {ImportedURL.SUPERADMIN.includes(account.role) &&
                                                                    <div className='btn_select_feedback' style={{ marginRight: '30px' }}>
                                                                        <Select
                                                                            options={[{ label: 'Guest Touch', value: 'guesttouch', to: '/myhotel-feedbacks' }, { label: 'MyHotel AI', value: 'myhotelai', to: '/feedbacks' }]}
                                                                            value={[{ label: 'Guest Touch', value: 'guesttouch', to: '/myhotel-feedbacks' }]}
                                                                            formatOptionLabel={(e) => (
                                                                                <div style={{ display: 'block', alignItems: 'center' }}>
                                                                                    <Link to={e.to} className='all_search_text_size'>{e.label}</Link>
                                                                                </div>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                }
                                                                {
                                                                    this.state.gridView
                                                                    &&
                                                                    <>
                                                                        {rowData && rowData.length ? <div className="d-flex justify-content-between align-items-center">
                                                                            <ul className="nav nav-tabs page-header-tab">
                                                                            </ul>
                                                                            <a className="btn btn-primary btn-sm nav-link dropdown-toggle export_btn_grid" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2 " aria-hidden="true"></i>Export</a>
                                                                            <div className="dropdown-menu">
                                                                                <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                                                <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                                            </div>
                                                                        </div> : ''}
                                                                    </>
                                                                }

                                                                <span className="input-group-btn ml-2">
                                                                    <button className="btn btn-sm btn-default fdb_doggulor" style={{ fontSize: "25px" }} onClick={() => { this.setState({ gridView: !this.state.gridView }) }}>
                                                                        {this.state.gridView ? <span className="fe fe-list"></span> : <span className="fe fe-grid"></span>}
                                                                    </button>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-2  col-12">
                                                            <label className="form-label">Limit</label>
                                                            <div className="form-group">
                                                                <Select
                                                                    onChange={(e) => { this.gridApi.paginationSetPageSize(Number(e.value)); this.setState({ todosPerPage: Number(e.value) }) }}
                                                                    options={limitOptions}
                                                                    defaultValue={limitOptions[0]}
                                                                    className='limit_size'
                                                                />
                                                            </div>
                                                        </div>
                                                        {
                                                            ImportedURL.SUPERADMIN.includes(account.role) &&
                                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                                <label className="form-label">Hotel</label>
                                                                <div className="form-group">
                                                                    <Select
                                                                        onChange={this.handleChange}
                                                                        options={hotelOptionsSearch}
                                                                        value={this.state.hotelLabel ? this.state.hotelLabel : ""}
                                                                        formatOptionLabel={(e) => (
                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                {e.label != 'All' && <img className='all_search_image_size contain_image' src={ImportedURL.FILEURL + e.logo} onError={onErrorImage} />}
                                                                                <div style={e.label != 'All' ? { paddingLeft: '10px' } : {}}><span className='all_search_text_size' >{e.label}</span></div>
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }

                                                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-12">
                                                            <div className="form-group">
                                                                <label className="form-label">From Date</label>
                                                                <div className='site_pass_calander'>
                                                                    <input type='date' className="form-control" name="fromDate" value={this.state.fromDate} onChange={this.setDate}></input>
                                                                    <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className=" col-xl-2 col-lg-2 col-md-6 col-sm-6 col-12">
                                                            <div className="form-group">
                                                                <label className="form-label">To Date</label>
                                                                <div className='site_pass_calander'>
                                                                    <input type='date' className="form-control" name="toDate" min={this.state.fromDate ? this.state.fromDate : ''} onChange={this.setDate} value={this.state.toDate}></input>
                                                                    <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.hideReset ?
                                                            <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3 d-flex align-items-center">
                                                                <button className='btn social_rest_btn btn-primarys' type='button' onClick={this.filterReset}><i className="fa fa-refresh" aria-hidden="true" style={{ fontSize: '20px !importent', marginRight: '7px' }}></i> Reset</button>
                                                            </div> : ''}
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={this.state.gridView ? { display: 'none' } : {}}>
                                                {currentfeedbacks && currentfeedbacks.map((data, i) => {
                                                    return <div className="card" key={i}>
                                                        <div className="card-body fback_body">
                                                            <div className='image_size_fd'>
                                                                <Row>
                                                                    <div className='col-xl-1 col-lg-1 col-md-2 col-12 col-12'>
                                                                        <div className='img_size'>
                                                                            <img className="avatar avatar-xl mr-3" src={data.hotel && data.logo ?
                                                                                ImportedURL.FILEURL + data.logo : 'assets/images/defaultuser.png'}
                                                                                onError={(e) => { if (e.target.src !== "assets/images/defaultuser.png") { e.target.onerror = null; e.target.src = "assets/images/defaultuser.png"; } }
                                                                                }
                                                                                alt="" />
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xl-10 col-lg-10 col-md-9 col-12 col-12'>
                                                                        <div className='rating'>
                                                                            <p className='mb-0'>
                                                                                <span className="h6">Room No. : {data.roomno} </span>
                                                                                <p style={{ fontSize: '13px', fontWeight: '600', marginBottom: '0px' }}>{data.hotelName ? `${data.hotelName}` : ''}</p>
                                                                                <p className='mb-0' style={{ fontSize: '14px' }}> {data.namedetails}</p>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </Row>
                                                            </div>
                                                            <article className="media">
                                                                <div className="media-body">
                                                                    <div className="content">
                                                                        {data.feedback ?
                                                                            <div className="chat_windows">
                                                                                <ul className="mb-0 pl-0">
                                                                                    <li className="my-message">
                                                                                        <div className="message">
                                                                                            <div className='col-sm-12 col-md-12 mt-3'>
                                                                                                <div style={{ display: 'flex', justifyContent: 'start' }}>
                                                                                                    <div style={{ position: 'relative' }}>
                                                                                                        <p className="bg-light-gray received">{data.feedback}</p>
                                                                                                        <span className="time received-time">{this.getDate(data.date_text_sent)}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                            : ''}

                                                                    </div>
                                                                </div>
                                                            </article>
                                                        </div>
                                                    </div>
                                                }
                                                )}

                                                {rowData.length > 0 ?
                                                    <ul className="pagination mt-2">
                                                        {renderPrevBtn}
                                                        {pageDecrementBtn}
                                                        {renderPageNumbers}
                                                        {pageIncrementBtn}
                                                        {renderNextBtn}
                                                    </ul> :
                                                    spinner ?
                                                        ""
                                                        :
                                                        <div className="card-body no_records text-center d-flex align-items-center justify-content-center">
                                                            <div style={{ maxWidth: "340px" }}>
                                                                <img src="../assets/images/nothing-here.png" alt="..." className="img-fluid mb-4 mt-4" style={{ maxWidth: "272px" }} />
                                                                <h5 className="mb-2">No records to display </h5>
                                                            </div>
                                                        </div>}
                                            </div>
                                            <div className="card" style={!this.state.gridView ? { display: 'none' } : {}}>
                                                <div className="card-body">
                                                    <div className="table-responsive pt-3">
                                                        <div className="ag-theme-alpine">
                                                            <AgGridReact
                                                                rowHeight={82}
                                                                paginationPageSize={25}
                                                                pagination={true}
                                                                onRowClicked={this.onRowClicked}
                                                                domLayout={"autoHeight"}
                                                                defaultColDef={this.state.defaultColumDef}
                                                                onGridReady={this.onGridReady}
                                                                rowData={rowData}
                                                                columnDefs={this.state.columnDefs}
                                                                overlayNoRowsTemplate={"No rows to display"}
                                                            >
                                                            </AgGridReact>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="overlay" style={{ display: spinner ? 'block' : 'none' }}></div>
                        <div className="section-body">
                            <div className="container-fluid">
                                <div className="tab-content">
                                    <div className="modal fade" id="listreportmodel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                        <div className="modal-dialog latest_review_modal" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <div className='rounded_icon'><i className="fa fa-comments mr-2"></i></div>
                                                    <h5 className="modal-title" id="exampleModalLabel" style={{ marginTop: '5px' }}> {languageData && languageData.VIEW ? languageData.VIEW : "View"}{languageData && languageData.FEEDBACK ? languageData.FEEDBACK : "Feedback"}</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true" style={{ fontSize: "23px" }}>
                                                            <img src='../../assets/images/cancel.png' />
                                                        </span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="modal-body">
                                                        <article className="media">
                                                            <div className="mr-3">
                                                                <img className="avatar avatar-xl" src={viewfeedbackData && viewfeedbackData.logo ?
                                                                    ImportedURL.FILEURL + viewfeedbackData.logo : 'assets/images/defaultuser.png'}
                                                                    onError={(e) => { if (e.target.src !== "assets/images/defaultuser.png") { e.target.onerror = null; e.target.src = ImportedURL.LOCALURL + "assets/images/defaultuser.png"; } }} alt=""
                                                                />
                                                            </div>
                                                            <div className="media-body">
                                                                <div className="content">
                                                                    <p className="h5"><span className='pr-2'>{viewfeedbackData.name}</span>
                                                                        <small className="float-right text-muted">{viewfeedbackData.createdAt ? moment(viewfeedbackData.createdAt).format(dtFormat) : ''}</small>
                                                                    </p>
                                                                    <p>
                                                                        <small className='pt-2'>{viewfeedbackData.phone}</small>
                                                                        <small className="float-right text-muted">{viewfeedbackData.hotelName ? `${viewfeedbackData.hotelName}` : ''}</small>
                                                                    </p>
                                                                    <p dangerouslySetInnerHTML={{ __html: viewfeedbackData.feedback }} className="mt-3"></p>
                                                                </div>
                                                            </div>
                                                        </article>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="overlay" style={{ display: this.state.spinner ? 'block' : 'none' }}></div>
                    {
                        this.state.spinner &&
                        <div className='common_loader'>
                            <img className='loader_img_style_common' src='../../assets/images/load.png' />
                            <Spinner className='spinner_load_common' animation="border" variant="info" >
                            </Spinner>
                        </div>
                    }
                </div>

            </>
        )
    }
}
const mapStateToProps = state => ({
    fixNavbar: state.settings.isFixNavbar,
    ReviewState: state.review,
    HotelState: state.hotel,
    AccountState: state.account,
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ ListHotel: AC_LIST_HOTEL, ListFeedback: AC_LIST_FEEDBACK, ResetFeedback: AC_RESET_FEEDBACK }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(ListFeedback);